﻿/* 
Object:         User (Gebruiker)
Description:    Logic and events for the module User (Gebruiker)
Used in:        User / Tabstrip User
*/

/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true
*/

window.user = function () {
    // constants
    var PagerVersionWPagerProfiles = 370;

    // messages
    var E_Check_P2000_notification = "";
    var E_Check_Precom_notification = "";
    var E_Check_Agendaonderbezetting_notification = "";
    var E_Check_Alarmenonderbezetting_notification = "";
    var E_Check_Uitrukvoorstel_notification = "";

    var currentSelectedGroupId;
    var currentSelectedAdditionalGroupId;

    return {

        /**
        * Init (binding button actions)
        * @param { any } DOMelement
        */
        initialize: function () {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("User/Add");
            });
        },

        /**
        * Delete a user (user message 'confirm to remove')
        * @param { any } DOMelement
        */
        deleteItem: function (e) {

            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                user.removeUser(dataItem.UserID);
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        /**
        * Action remove a user (from the grid)
        * @param { any } UserId
        */
        removeUser: function (userId) {

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/Delete") + "?userId=" + userId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    navigation.navigateToSpecificUrl("Module/LoadModule");
                }
            });
        },

        copyItem: function (e) {
            // Prevent default behaviour
            e.preventDefault();

            // Set mode 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // select the item
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("User/Copy?userId=" + dataItem.UserID + "&breadcrumbLabel=" + dataItem.FullName);
        },

        /**
        * Action edit a user (from the grid)
        * Redirects to the user to edit with the id
        * @param { any } Selected_DOMElement
        */
        editItem: function (e) {
            // Prevent default behaviour
            e.preventDefault();

            // Set mode 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // select the item
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("User/Edit_Tabstrip?userId=" + dataItem.UserID + "&breadcrumbLabel=" + dataItem.FullName);
        },

        /**
        * Show a item from the grid. (action)
        * @param { any } Selected_DOMElement
        */
        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Set mode
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // select the item
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("User/Show_Tabstrip?userId=" + dataItem.UserID + "&breadcrumbLabel=" + dataItem.FullName);
        },

        extraToolbarButton0_Clicked: function () {
            var url = 'User/ExportAllUsersCurrentNode';
            var filename = 'Export_UsersAll_' + fileDownload.getDateTimeString() + '.xlsx';
            var loaderId = 'extraToolbarButton0Loader';
            fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
        },

        extraToolbarButton1_Clicked: function () {
            var url = 'User/ExportAllUsersNodesDown';
            var filename = 'Export_UsersAll_' + fileDownload.getDateTimeString() + '.xlsx';
            var loaderId = 'extraToolbarButton1Loader';
            fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
        },

        extraToolbarButton2_Clicked: function () {
            var url = 'User/ExportAllPagerConfig';
            var filename = 'Export_UsersAllPagerConfig_' + fileDownload.getDateTimeString() + '.xlsx';
            var loaderId = 'extraToolbarButton2Loader';
            fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
        },

        extraToolbarButton3_Clicked: function () {
            var url = 'User/ExportAllPagerConfigNodesDown';
            var filename = 'Export_UsersAllDownPagerConfig_' + fileDownload.getDateTimeString() + '.xlsx';
            var loaderId = 'extraToolbarButton3Loader';
            fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
        },

        /**
        * Init tab general
        * @param { any } Selected_DOMElement
        */
        init_Tab_General: function (msg_Check_P2000_notification,
            msg_Check_Precom_notification,
            msg_Check_Agendaonderbezetting_notification,
            msg_Check_Alarmenonderbezetting_notification,
            msg_Check_Uitrukvoorstel_notification) {

            E_Check_P2000_notification = msg_Check_P2000_notification;
            E_Check_Precom_notification = msg_Check_Precom_notification;
            E_Check_Agendaonderbezetting_notification = msg_Check_Agendaonderbezetting_notification;
            E_Check_Alarmenonderbezetting_notification = msg_Check_Alarmenonderbezetting_notification;
            E_Check_Uitrukvoorstel_notification = msg_Check_Uitrukvoorstel_notification;

            $("#NewPassword").val('');
        },

        /**
        * Response
        * @param {bool} succesfully
        * @param {string} msg
        */
        makeResponseData: function (succesfully, msg) {
            this.Succesfully = succesfully;
            this.Message = msg;
        },

        /**
        * Form submission
        * @param {event} e
        */
        onFormSubmit: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            var validateStr = user.clientSideValidation();

            if (validateStr != "") {
                var responseData = new user.makeResponseData(false, validateStr);
                form.showServerResponse(responseData);
            }
            else {
                // Post Data
                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl(e.model.FormAction),
                    data: e.model,
                    success: function (responseData) {
                        form.showServerResponse(responseData);
                    }
                });
            }
        },

        /*

        */

        validateNotification: function () {

            var validateResult = "";

            var valANVal = main.getKendoCheckBoxGroupValue("ANVal");
            var valPNVal = main.getKendoCheckBoxGroupValue("PNVal");

            if (!(valANVal & 4) && !(valPNVal & 4)) {
                validateResult += E_Check_P2000_notification + "\r\n";
            }

            if (!(valANVal & 1) && !(valPNVal & 1)) {
                validateResult += E_Check_Precom_notification + "\r\n";
            }

            if (!(valANVal & 2) && !(valPNVal & 2)) {
                validateResult += E_Check_Agendaonderbezetting_notification + "\r\n";
            }

            if (!(valANVal & 8) && !(valPNVal & 8)) {
                validateResult += E_Check_Alarmenonderbezetting_notification + "\r\n";
            }

            if (!(valANVal & 16) && !(valPNVal & 16)) {
                validateResult += E_Check_Uitrukvoorstel_notification + "\r\n";
            }

            return validateResult;
        },


        /**
        * Client side validation
        */
        clientSideValidation: function () {
            var notificationValStr = user.validateNotification();

            var txtarea = $("#notificationvalidation").data("kendoTextArea");            
            if (txtarea != undefined) {
                txtarea.value(notificationValStr);
            }

            main.setHideDivBootstrap("DivValidateNotification", notificationValStr != "");
        },


        //--- TAB ROLES ---------------------------------------------------------------------------//

        /**
        * Init Tab roles
        * @param {string} notsaved
        */
        TAB_Roles_initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },

        /**
        * Tab roles - Enable save button
        */
        TAB_Roles_enableSaveButton: function () {
            $("#saveButtonRoles").data("kendoButton").enable(true);
        },

        /**
        * Tab roles - Disable save button
        */
        TAB_Roles_disableSaveButton: function () {
            $("#saveButtonRoles").data("kendoButton").enable(false);
        },

        /**
        * Tab roles - Left clicked
        */
        TAB_Roles_leftClicked: function () {
            user.TAB_Roles_enableSaveButton();
            listbox.moveItems("User_Roles_CplSelected", "User_Roles_CplNotSelected", "#Roles_Validation", user.TAB_Roles_Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab roles - Right clicked
        */
        TAB_Roles_rightClicked: function () {
            user.TAB_Roles_enableSaveButton();
            listbox.moveItems("User_Roles_CplNotSelected", "User_Roles_CplSelected", "#Roles_Validation", user.TAB_Roles_Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab roles - Save button clicked
        * @param {string} actionUrl
        * @param {number} userId
        */
        TAB_Roles_saveButtonClicked: function (actionUrl, userId) {

            user.TAB_Roles_disableSaveButton();

            var json = $("#User_Roles_CplSelected").data("kendoListBox").dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), id: userId },
                success: function (responseData) {

                    $('#Roles_Validation').text("");

                    if (responseData.Success) {

                    } else {
                        $('#User_Roles_CplNotSelected').data("kendoListView").dataSource.read();
                        $('#User_Roles_CplSelected').data("kendoListView").dataSource.read();
                    }

                    var color = (responseData.Success ? 'green' : 'red');
                    $('#Roles_Validation').text(responseData.Message);
                    $('#Roles_Validation').attr('style', 'color:' + color);
                }
            });

        },

        //--- TAB FUNCTIONS ---------------------------------------------------------------------------//

        /**
        * Tab functions - Init tab
        * @param {string} notsaved
        */
        TAB_Functions_initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },

        /**
        * Tab functions - LDataNotSaved (label)
        */
        TAB_Functions_Get_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        /**
        * Tab functions - Left clicked (move items)
        */
        TAB_Functions_leftClicked: function () {
            user.TAB_Functions_enableSaveButton();
            listbox.moveItems("User_Functions_CplSelected", "User_Functions_CplNotSelected", "#Functions_Validation", user.TAB_Functions_Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab functions - Right clicked (move items)
        */
        TAB_Functions_rightClicked: function () {
            user.TAB_Functions_enableSaveButton();
            listbox.moveItems("User_Functions_CplNotSelected", "User_Functions_CplSelected", "#Functions_Validation", user.TAB_Functions_Get_LDataChangedNotSavedYet);
        },

        /**
        * Tab functions - Enable save button
        */
        TAB_Functions_enableSaveButton: function () {
            $("#saveButtonFunctions").data("kendoButton").enable(true);
        },

        /**
        * Tab functions - Disable save button
        */
        TAB_Functions_disableSaveButton: function () {
            $("#saveButtonFunctions").data("kendoButton").enable(false);
        },

        /**
        * Tab functions - Move selected item
        * @param {string} actionUrl
        * @param {string} userId
        */
        TAB_Functions_saveButtonClicked: function (actionUrl, userId) {

            user.TAB_Functions_disableSaveButton();

            var listBox = $("#User_Functions_CplSelected").getKendoListBox();
            listBox.dataSource.filter({ field: "Text", operator: "contains", value: "" });

            var json = listBox.dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), id: userId },
                success: function (responseData) {

                    $('#Functions_Validation').text("");

                    var color = (responseData.Success ? 'green' : 'red');
                    $('#Functions_Validation').text(responseData.Message);
                    $('#Functions_Validation').attr('style', 'color:' + color);
                }
            });
        },

        /**
        * Tab functions - Visibility
        * @param {string} version
        */
        tab_General_Visibility: function (version) {

            var val = main.getKendoCheckBoxGroupValue("ANVal");

            main.setHideDivBootstrap("DivSoundsHeader", val > 0);

            main.setHideDivBootstrap("DivSoundAlarm", (val & 4) > 0);
            main.setHideDivBootstrap("DivSoundInfo", (val & 1) > 0);
            main.setHideDivBootstrap("DivSoundUnderstaffing", (val & 2) > 0);
            main.setHideDivBootstrap("DivSoundOccupancy", (val & 8) > 0);
            main.setHideDivBootstrap("DivSoundProposal", (val & 16) > 0);

            main.setHideDivBootstrap("DivGroupChangeMsgBy", version >= PagerVersionWPagerProfiles);

            user.clientSideValidation();
        },

        //--- TAB Pager ---------------------------------------------------------------------------//

        TAB_UserPager_Profile_Refresh: function (userId, profileNumber) {
            $("#editTabstripUserPager-1").empty();
            $("#editTabstripUserPager-1").load(appsettings.getUrl("User/Tab_Pager_Profile?userId=" + userId + "&number=" + profileNumber));
        },

        TAB_UserPager_Profile_Capcodes_Refresh: function (userId, profileNumber) {
            $("#DivProfileCapcodes").load(appsettings.getUrl("User/Tab_Pager_Profile_Capcodes?userId=" + userId + "&profileNumber=" + profileNumber));
        },

        TAB_UserPager_Profile_Checked: function (checked) {            
            $("[id$='_Capcode']").prop('disabled', !checked.checked);
            $("[id$='_Active']").prop('disabled', !checked.checked);
            $("[id$='_Prio']").prop('disabled', !checked.checked);
            $("[id$='_Manual']").prop('disabled', !checked.checked);
            $("[id$='_Reply']").prop('disabled', !checked.checked);
            $("[id$='_TGS']").prop('disabled', !checked.checked);
            $("[id$='_TGScode']").prop('disabled', !checked.checked);
            $("[id$='_Label']").prop('disabled', !checked.checked);
            $("[id$='_AlertType']").prop('disabled', !checked.checked);
            $("[id$='_UserTonePattern']").prop('disabled', !checked.checked);
        },

        TAB_UserPager_Profile_TGSChanged: function (e) {
            var tGSCodeDiv = $("#" + e.sender.element[0].id.replaceAll('_TGS', '_TGScode')).parent().closest('div')[0];
            user.setHideDiv(tGSCodeDiv, e.checked);
        },

        TAB_UserPager_Profile_AlertTypeChanged: function (e) {
            var userTonePatternDiv = $("#" + e.sender.element[0].id.replaceAll('_AlertType', '_UserTonePattern')).parent().closest('div')[0];

            if (e.sender.element[0].value == "0") {
                user.setHideDiv(userTonePatternDiv, true);
            } else {
                user.setHideDiv(userTonePatternDiv, false);
            }
        },

        setHideDiv: function (element, showBool) {
            if (element !== undefined && element !== null) {

                if (element.style != undefined) {
                    if (showBool) {
                        element.style.visibility = "visible";  // "inline";
                    } else {
                        element.style.visibility = "hidden";
                    }
                } else {
                    element[0].hidden = !showBool;
                }

            }

            /*$("#" + id + " input").attr("data-validate", showBool);*/
        },

        TAB_UserPager_CancelForm_Clicked: function () {
            history.back();
        },

        TAB_UserPager_SubmitForm_Clicked: function (formid, actionUrl) {
            if ($("#form_Tab_Pager_Profile")[0] != null) {
                var formId_profile = $("#form_Tab_Pager_Profile").find("input#FormName").val();
                var formAction_profile = $("#form_Tab_Pager_Profile").find("input#FormAction").val();
                form.submitForm(formId_profile, formAction_profile, false, '');
            }

            form.submitForm(formid, actionUrl, false, '');
        },

        onPagerFormSubmit: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl(e.model.FormAction),
                data: e.model,
                success: function (responseData) {
                    form.showServerResponse(responseData);
                }
            });
        },

        TAB_UserPager_AccuGSMSignal_Clicked: function (userId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/PagerRequestAccuGSMSignal") + "?userId=" + userId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }
            });
        },
        
        TAB_UserPager_Send_Clicked: async function (formid, actionUrl, userId) {

            // 1. submit form
            if ($("#form_Tab_Pager_Profile")[0] != null) {
                var formId_profile = $("#form_Tab_Pager_Profile").find("input#FormName").val();
                var formAction_profile = $("#form_Tab_Pager_Profile").find("input#FormAction").val();
                form.submitForm(formId_profile, formAction_profile, false, '');
            }

            var response = await form.submitForm(formid, actionUrl, false, '');

            if (response.Succesfully) {
                // 2. send to pager
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("User/PagerSend") + "?userId=" + userId,
                    success: function (responseData) {

                        if (responseData != undefined && responseData != null) {
                            main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }
                });
            }
        },

        TAB_UserPager_Request_Clicked: function (userId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/PagerRequest") + "?userId=" + userId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);

                        //TODO:
                        //main.setHideDiv("BRefresh", true);
                    }
                }
            });
        },

        TAB_UserPager_Refresh_Clicked: function (userId) {
            var tabstrip = $('#userPager_Refresh').closest(".k-tabstrip").first().data("kendoTabStrip");
            var tab = tabstrip.select();
            tabstrip.reload(tab);
        },

        TAB_UserPager_BSendNac_Clicked: function (userId) {
            var selectedNacId = $("#NacId").data("kendoDropDownList").value();
            
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/Update_Provider_Nac") + "?userId=" + userId + "&nacId=" + selectedNacId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }
            });
        },

        TAB_UserPager_BSendCancelLocation_Clicked: function (userId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/Send_Cancel_Location") + "?userId=" + userId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }
            });
        },

        //--- TAB UserGroupChange ---------------------------------------------------------------------------//

        TAB_UserGroupChange_GetListBoxSelectedValue: function (listboxName) {
            var listBox = $(listboxName).data("kendoListBox");
            var allItems = listBox.items();
            var selectedItems = listBox.select();

            var index = allItems.index(selectedItems[0]);
            var item = listBox.dataSource.view()[index];
            if (item != undefined) {
                return item.Value;
            } else {
                return -1;
            }            
        },

        TAB_UserGroupChange_SetListBoxSelectedValue: function (listboxName, value) {
            var listBox = $(listboxName).data("kendoListBox");

            var items = listBox.dataItems().filter(f => f.Value == value);
            if (items !== undefined) {
                var item = listBox.wrapper.find("[data-uid='" + items[0].uid + "']");
                listBox.select(item);
            }
        },

        TAB_UserGroupChange_GroupAdd_Clicked: function (formId, userId) {
            var actionUrl = "User/UserGroupChange_GroupAdd";
            var fieldName = "#TBGroupChangeGroup";
            var data = { userId: userId, ID: parseInt($(fieldName).val()) };

            form.submitData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

            currentSelectedGroupId = undefined;
            currentSelectedAdditionalGroupId = undefined;
        },

        TAB_UserGroupChange_AdditionalGroupAdd_Clicked: function (formId) {
            var actionUrl = "User/UserGroupChange_AdditionalGroupAdd";
            var userGroupChangeId = parseInt(user.TAB_UserGroupChange_GetListBoxSelectedValue("#LBoxUserGroupChange_Groups"));
            var fieldName = "#TBGroupChangeAdditionalGroup";
            var data = { userGroupChangeId: userGroupChangeId, ID: parseInt($(fieldName).val()) };

            form.submitData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

            currentSelectedAdditionalGroupId = undefined;
        },

        TAB_UserGroupChange_AdditionalFunctionAdd_Clicked: function (formId) {
            var actionUrl = "User/UserGroupChange_AdditionalFunctionAdd";
            var userGroupChangeAdditionalGroupId = parseInt(user.TAB_UserGroupChange_GetListBoxSelectedValue("#LBoxUserGroupChange_AdditionalGroups"));
            var fieldName = "#DDLGroupChangeAdditionalFunction";
            var data = { userGroupChangeAdditionalGroupId: userGroupChangeAdditionalGroupId, serviceFunctionId: parseInt($(fieldName).val()) };

            form.submitData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');
        },

        TAB_UserGroupChange_GroupDelete_Clicked: function (formId) {
            var actionUrl = "User/UserGroupChange_GroupDelete";
            var fieldName = "#LBoxUserGroupChange_Groups";
            var userGroupChangeId = user.TAB_UserGroupChange_GetListBoxSelectedValue(fieldName);

            var data = { userGroupChangeId: parseInt(userGroupChangeId) };

            form.deleteData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

            currentSelectedGroupId = undefined;
            currentSelectedAdditionalGroupId = undefined;
        },

        TAB_UserGroupChange_AdditionalGroupDelete_Clicked: function (formId) {
            var actionUrl = "User/UserGroupChange_AdditionalGroupDelete";
            var fieldName = "#LBoxUserGroupChange_AdditionalGroups";
            var userGroupChangeAdditionalGroupId = user.TAB_UserGroupChange_GetListBoxSelectedValue(fieldName);

            var data = { userGroupChangeAdditionalGroupId: parseInt(userGroupChangeAdditionalGroupId) };

            form.deleteData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');

            currentSelectedAdditionalGroupId = undefined;
        },

        TAB_UserGroupChange_AdditionalFunctionDelete_Clicked: function (formId) {
            var actionUrl = "User/UserGroupChange_AdditionalFunctionDelete";
            var fieldName = "#LBoxUserGroupChange_AdditionalFunctions";
            var userGroupChangeAdditionalFunctionId = user.TAB_UserGroupChange_GetListBoxSelectedValue(fieldName);

            var data = { userGroupChangeAdditionalFunctionId: parseInt(userGroupChangeAdditionalFunctionId) };

            form.deleteData(formId, actionUrl, fieldName, data, false, true, '#editTabstripUser');
        },

        TAB_UserGroupChange_LBox_Groups_Clicked: function (userId, e) {
            var fieldNameG = "#LBoxUserGroupChange_AdditionalGroups";
            var element = e.sender.select();
            var userGroupChangeId = e.sender.dataItem(element[0]).Value;
            user.filterData(fieldNameG, userGroupChangeId);

            var fieldNameF = "#LBoxUserGroupChange_AdditionalFunctions";
            var userGroupChangeAdditionalGroupId = parseInt($('#LBoxUserGroupChange_AdditionalGroups').val());
            user.filterData(fieldNameF, userGroupChangeAdditionalGroupId);

            user.TAB_UserGroupChange_Refresh_AdditionalFunction(userId, userGroupChangeAdditionalGroupId);

            currentSelectedGroupId = userGroupChangeId;
            currentSelectedAdditionalGroupId = undefined;
        },

        TAB_UserGroupChange_LBox_AdditionalGroups_Clicked: function (userId, e) {
            var fieldName = "#LBoxUserGroupChange_AdditionalFunctions";
            var element = e.sender.select();
            var userGroupChangeAdditionalGroupId = e.sender.dataItem(element[0]).Value;
            user.filterData(fieldName, userGroupChangeAdditionalGroupId);

            user.TAB_UserGroupChange_Refresh_AdditionalFunction(userId, userGroupChangeAdditionalGroupId);

            currentSelectedAdditionalGroupId = userGroupChangeAdditionalGroupId;
        },

        TAB_UserGroupChange_Refresh_All: function (userId) {

            if (currentSelectedGroupId === undefined) {
                var listBox_Groups = $("#LBoxUserGroupChange_Groups").data("kendoListBox");
                listBox_Groups.select(listBox_Groups.items().first());
            }
            else {
                user.TAB_UserGroupChange_SetListBoxSelectedValue("#LBoxUserGroupChange_Groups", currentSelectedGroupId);
            }

            var userGroupChangeId = parseInt(user.TAB_UserGroupChange_GetListBoxSelectedValue("#LBoxUserGroupChange_Groups"))
            user.filterData("#LBoxUserGroupChange_AdditionalGroups", userGroupChangeId);

            var userGroupChangeAdditionalGroupId;
            if (currentSelectedAdditionalGroupId === undefined) {
                var listBox_AdditionalGroups = $("#LBoxUserGroupChange_AdditionalGroups").data("kendoListBox");
                listBox_AdditionalGroups.select(listBox_AdditionalGroups.items().first());
                userGroupChangeAdditionalGroupId = parseInt($('#LBoxUserGroupChange_AdditionalGroups').val());
            }
            else {
                user.TAB_UserGroupChange_SetListBoxSelectedValue("#LBoxUserGroupChange_AdditionalGroups", currentSelectedAdditionalGroupId);
                userGroupChangeAdditionalGroupId = currentSelectedAdditionalGroupId;
            }

            user.filterData("#LBoxUserGroupChange_AdditionalFunctions", userGroupChangeAdditionalGroupId);
            listBox_AdditionalGroups.select(listBox_AdditionalGroups.items().first());

            user.TAB_UserGroupChange_Refresh_AdditionalFunction(userId, userGroupChangeAdditionalGroupId);

            var listBox_AdditionalFunctions = $("#LBoxUserGroupChange_AdditionalFunctions").data("kendoListBox");
            listBox_AdditionalFunctions.select(listBox_AdditionalFunctions.items().first());
        },

        TAB_UserGroupChange_Refresh_AdditionalFunction: function (userId, userGroupChangeAdditionalGroupId) {
            // Get Data
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/GetAllFunctionsUser"),
                data: { userId: userId, userGroupChangeAdditionalGroupId: userGroupChangeAdditionalGroupId },
                success: function (responseData) {
                    if (responseData != undefined) {
                        var dropDownList = $("#DDLGroupChangeAdditionalFunction").data("kendoDropDownList");
                        dropDownList.dataSource.data(responseData.selectListItems);
                    }
                }
            });
        },

        filterData: function (fieldName, searchString) {
            var listBox = $(fieldName).getKendoListBox();

            listBox.dataSource.filter({ field: "ParentValue", operator: "contains", value: searchString });
        },
    }
}();